import request, { format } from '@/utils/request';
import { stringify } from 'qs';

const AJAX_URL = {
  REPORT_RELEASE_BEFORE_AUDIT_CHECK: '/mdc/shop/report/publishBeforeAudit/check',
  ADD_RELEASE_BEFORE_AUDIT_CHECK: '/mdc/shopAdd/publishBeforeAudit/check',
};

export const fetchReleaseBeforeAuditCheck = payload => {
  const { pageType, ...params } = payload;
  params.sceneInfo = {
    sceneInfoExt: {
      userSubmitScene: 1,
      confirmProtocol: 0,
    },
  };

  if (pageType !== 'add') {
    if (params.businessHoursObj) {
      params.businessHours = JSON.stringify(params.businessHoursObj);
      params.businessHoursObj = null;
    }
  }
  return format(
    request(
      pageType === 'add'
        ? AJAX_URL.ADD_RELEASE_BEFORE_AUDIT_CHECK
        : AJAX_URL.REPORT_RELEASE_BEFORE_AUDIT_CHECK,
      {
        method: 'POST',
        body: { pageType: pageType === 'add' ? null : pageType, ...params },
      }
    )
  );
};

export const fetchQrCodeToken = () => {
  return format(request('/mdc/shop/report/qrcode'));
};

export const fetchLocationPolling = payload => {
  if (!payload?.token) return;
  return format(request(`/mdc/shop/report/location?${stringify(payload)}`));
};
